module.exports = __webpack_public_path__ + "static/media/george-ford.a13ddbb3.jpg";